import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import { Link } from "react-router-dom";
import moment from "moment";
import ConfirmMessagePopUpModal from "./../PopUp/ConfirmMessagePopUpModal"
import { ContextMenu, MenuItem, ContextMenuTrigger, showMenu, hideMenu } from "react-contextmenu";
import AlertMessagePopUpModal from "../GenAIPopUp/AlertMessagePopUpModal";
// import { sanitize } from 'dompurify';
import DOMPurify from "dompurify";
const sanitize = DOMPurify.sanitize;

class GenAIProjectItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customWidth: props.customWidth,
            customHeight: props.customHeight,
            source: props.source,
            confirmMessageContent: '',
            confirmMessageShowModal: false,
            confirmMessageId: -1,
            alertMessageModelColor: "",
            alertMessageContent: "",
            alertMessageShowModal: false,
        }
    }
   

    renderDisplayString = () => {
        let { display_string_multi_files, output_answer } = this.state.source.authoringinfo;
        let { source } = this.state;
        if (display_string_multi_files.length > 0) {

            let finalDisplayString = display_string_multi_files.map((dsitem, dsindex) => {
                let display_ans = dsitem.display_ans.replace(/<br\/>/g, '').replace(/<br>/g, '')
                let temp = [];
                const div = document.createElement('div');
                let _sectionData = display_ans;
                if (_sectionData) {
                    _sectionData = _sectionData.replace(/<br>·/g, '<br>');
                }
                div.innerHTML = _sectionData;
                const spans = div.getElementsByTagName('span');
                if (spans && spans.length > 0) {
                    for (let span = 0; span < spans.length; span++) {
                        temp.push(spans[span].innerHTML);
                    }

                    display_ans = temp.join('').replace(/<(?:.|\n)*?>/gm, ' ').replace(/<(?:.|\n)*?>/gm, ' ').replace(/\s{2,}/g, ' ').trim()
                } else {
                    display_ans = display_ans.replace(/<(?:.|\n)*?>/gm, ' ').replace(/<(?:.|\n)*?>/gm, ' ').replace(/\s{2,}/g, ' ').trim()
                }
                return display_ans;
            }).join(' ')
            if (window.location.pathname.startsWith('/genAILibraryPOC') ||
                window.location.pathname.startsWith('/genAICollectionPOC')) {
                return (<Link to={`/genAISearchPOC/${source.authoringinfo.session_id}`} title={finalDisplayString} dangerouslySetInnerHTML={{ __html: sanitize(`${finalDisplayString}`) }} className="gen-ai-answering-library-thread-item-ans">
                </Link>)
            }
            else {
                return (
                    <Link to={`/genAIAuthoring2Search/${source.authoringinfo.session_id}`} title={finalDisplayString} dangerouslySetInnerHTML={{ __html: sanitize(`${finalDisplayString}`) }} className="gen-ai-answering-library-thread-item-ans">
                    </Link>)
            }
        } else {
            if (output_answer === "We don't know the answer. Can you try new questions.") {
                output_answer = `No Answer found. Please try a new question.`;
            }
            if (window.location.pathname.startsWith('/genAILibraryPOC') ||
                window.location.pathname.startsWith('/genAICollectionPOC')) {
                return (
                    <Link to={`/genAISearchPOC/${source.authoringinfo.session_id}`} title={output_answer} dangerouslySetInnerHTML={{ __html: sanitize(`${output_answer}`) }} className="gen-ai-answering-library-thread-item-ans">
                    </Link>)
            }
            else {
                return (
                    <Link to={`/genAIAuthoring2Search/${source.authoringinfo.session_id}`} title={output_answer} dangerouslySetInnerHTML={{ __html: sanitize(`${output_answer}`) }} className="gen-ai-answering-library-thread-item-ans">
                    </Link>)
            }
        }
    }
    showConfirmMessage = (message, id) => {
        this.setState({
            confirmMessageContent: message,
            confirmMessageShowModal: true,
            confirmMessageId: id
        })
    }

    confirmHandler = async () => {
        const { confirmMessageId } = this.state;
        this.setState(
            {
                confirmMessageContent: "",
                confirmMessageShowModal: false,
            },
            async () => {
                 await this.props.deleteAuthorProjectBySessionId(confirmMessageId);
                this.setState({ confirmMessageId: -1 });
            }
        );
    }


    closeConfirmMessage = () => {
        this.setState({
            confirmMessageContent: "",
            confirmMessageShowModal: false,
            confirmMessageIndex: -1
        })
    }
    handleDeleteProjectClick = (e, data) => {
        this.showConfirmMessage("Are you sure you want to delete this Project?", data._id)
    }
    successAlertMessage = (message) => {
        this.setState({
            alertMessageContent: message,
            alertMessageModelColor: "#EB1700",
            alertMessageShowModal: true
        })
    }
    errorAlertMessage = (message) => {
        this.setState({
            alertMessageContent: message,
            alertMessageModelColor: "#EB1700",
            alertMessageShowModal: true
        })
    }
    closeAlertMessage = () => {
        this.setState({
            alertMessageContent: "",
            alertMessageModelColor: "",
            alertMessageShowModal: false,
            showPreview: false
        })
    }
    handleLeftMouseClick = (e, _id) => {
        const x = e.clientX;
        const y = e.clientY;
        this.props.handleOnOpenedContextMenuClick(_id);
        showMenu({
            position: { x, y },
            id: _id
        });
    }
    onContextMenuHide = () => {
        this.props.handleOnOpenedContextMenuClick("");
    }
    componentWillReceiveProps(nextProps) {
        let { source } = this.state;
        if (nextProps && nextProps.openedContextMenuId !== source.authoringinfo.session_id
        ) {
            hideMenu({
                id: source.authoringinfo.session_id
            });
        }
        if (nextProps && nextProps.openedContextMenuId !== `CL-${source.authoringinfo.session_id}`) {
            hideMenu({
                id: `CL-${source.authoringinfo.session_id}`
            });
        }
    }
    render() {
        let { source } = this.state;
        let { updatedatehour } = this.state.source.eventinfo;
        const { confirmMessageContent, confirmMessageShowModal } = this.state;
        const { alertMessageModelColor, alertMessageContent, alertMessageShowModal, } = this.state;
        return (<>
            <div className="gen-ai-answering-library-thread-item">
                <div className="gen-ai-authering-project-details">
                   <div className="gen-ai-authering-project-name-wrapper">
                      <span>
                            <Link to={`/genAIAuthoring2Search/${source.authoringinfo.session_id}`} className="gen-ai-authering-project-name-label" title='Project Name'>
                                    Project Name:
                            </Link> 
                      </span>
                      <span>
                            <Link to={`/genAIAuthoring2Search/${source.authoringinfo.session_id}`} className="gen-ai-authering-project-name" title={source.authoringinfo.projectName}>
                                {source.authoringinfo.projectName}
                            </Link>
                      </span>
                    </div>
                    <div className="gen-ai-authering-project-type-wrapper">
                       <span>
                            <Link to={`/genAIAuthoring2Search/${source.authoringinfo.session_id}`} className="gen-ai-authering-project-type" title='Project Type:'>
                                    Project Type:
                            </Link> 
                        </span>
                        <span>
                             <Link to={`/genAIAuthoring2Search/${source.authoringinfo.session_id}`} className="gen-ai-authering-project-link" title={source.authoringinfo.projectType}>
                                {source.authoringinfo.projectType}
                             </Link>
                        </span>
                    </div> 
                 </div>

                <div className="gen-ai-answering-library-thread-item-title">
                    {(window.location.pathname.startsWith('/genAILibraryPOC')) ?
                        <Link to={`/genAISearchPOC/${source.authoringinfo.session_id}`} title={source.authoringinfo.question} className="gen-ai-answering-library-thread-item-title-link" >
                            {source.authoringinfo.question}
                        </Link> :
                         <Link to={`/genAIAuthoring2Search/${source.authoringinfo.session_id}`} title={source.authoringinfo.question} className="gen-ai-answering-library-thread-item-title-link" >
                            {source.authoringinfo.question}
                        </Link>
                        }
                </div>
                {this.renderDisplayString()}

                <div className="gen-ai-answering-library-thread-item-time-action">
                    <div className="gen-ai-answering-library-thread-item-time">
                        <div className="gen-ai-answering-library-thread-item-time-ago" title={moment(updatedatehour).format("MMM DD, YYYY hh:mm a")} data-state="closed">
                            <span>
                                <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="clock" className="svg-inline--fa fa-clock fa-sm " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                    <path fill="currentColor" d="M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"></path>
                                </svg>
                            </span>
                            <span className="truncate">&nbsp; {moment(updatedatehour).fromNow()}</span>
                        </div>
                    </div>
                    <div className="gen-ai-answering-library-thread-item-action">
                        {(!window.location.pathname.startsWith('/genAICollection/')) &&
                            <>
                                <div>
                                    <span>
                                        <ContextMenuTrigger id={source.authoringinfo.session_id} >
                                            <button data-testid="thread-dropdown-menu" onClick={e => this.handleLeftMouseClick(e, source.authoringinfo.session_id)} type="button" className="gen-ai-answering-library-thread-item-action-menu">

                                                <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="ellipsis" className="svg-inline--fa fa-ellipsis fa-fw fa-1x " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                                    <path fill="currentColor" d="M432 256a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-160 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM64 304a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"></path>
                                                </svg>
                                            </button>
                                        </ContextMenuTrigger>
                                        <ContextMenu id={source.authoringinfo.session_id} onHide={e => this.onContextMenuHide()} className="gen-ai-authering-project-item-contextMenu">
                                            <MenuItem data={{ _id: source.authoringinfo.session_id }} onClick={this.handleDeleteProjectClick}>
                                                <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="trash" className="svg-inline--fa fa-trash fa-fw " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M177.1 48h93.7c2.7 0 5.2 1.3 6.7 3.6l19 28.4h-145l19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0H177.1c-18.7 0-36.2 9.4-46.6 24.9L93.8 80H80.1 32 24C10.7 80 0 90.7 0 104s10.7 24 24 24H35.6L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3H324.6c33.5 0 61.3-25.9 63.8-59.3L412.4 128H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H367.9 354.2zm10.1 48L340.5 449.2c-.6 8.4-7.6 14.8-16 14.8H123.4c-8.4 0-15.3-6.5-16-14.8L83.7 128H364.3z"></path></svg>
                                                <span>Delete Project</span>
                                            </MenuItem>
                                        </ContextMenu>
                                    </span>
                                </div>
                            </>}
                    </div>
                </div>
            </div>
            {confirmMessageShowModal && <ConfirmMessagePopUpModal content={confirmMessageContent} showModal={confirmMessageShowModal} handleClose={() => this.closeConfirmMessage()} handleConfirm={() => this.confirmHandler()} />}
            {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
        </>)
    }
}
export default withRouter(GenAIProjectItem);

